import React, { useMemo } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';
import { MenuIconsId } from '../../../core/constants/menuIconsId';

import { menuSectionStore } from '../../../store/menuSectionStore';

import PayTableWrapper from './payTable';
import GameRulesWrapper from './gameRules';

const Info = observer(
  ({ PayTableContent, GameRulesContent, payTableStepCount, payTableContentWidth }) => {
    const { isShowMenuPopup, selectedIconId } = menuSectionStore;
    const SelectedMenuSection = useMemo(() => {
      return {
        [MenuIconsId.PayTable]: (
          <PayTableWrapper
            PayTableContent={PayTableContent}
            payTableStepCount={payTableStepCount}
            payTableContentWidth={payTableContentWidth}
          />
        ),
        [MenuIconsId.GameRules]: (
          <Container name='GameRulesSection'>
            <GameRulesWrapper x={isMobile() ? 10 : 162} GameRulesContent={GameRulesContent} />
          </Container>
        ),
      };
    }, [PayTableContent, payTableStepCount, payTableContentWidth, GameRulesContent]);

    return (
      <Container name='InfoContainer' visible={isShowMenuPopup}>
        {SelectedMenuSection[selectedIconId]}
      </Container>
    );
  }
);

export default Info;
